import './carousel.scss';

riot.tag2('ui-carousel', '<yield></yield>', '', '', function(opts) {
    this.mixin('bus');
    const self = this;
    const animationEvents = ['transitionend', 'webkitTransitionEnd'];
    const trackingHandler = require('../../core/trackingManager');

    let slides = [];
    let indicators = [];
    let indicatorContainer;
    let leftArrow;
    let rightArrow;
    let currentSlideIndex = 0;
    let prevSlideIndex;
    let nextSlideIndex;
    let animating = false;
    let direction;
    let touchStart = 0;
    let touchEnd = 0;

    function updateIndexes(delta = 1) {
      if (direction === 'right') {
        currentSlideIndex = (currentSlideIndex - delta >= 0) ? currentSlideIndex - delta : slides.length - delta;
      } else if (direction === 'left') {
        currentSlideIndex = (currentSlideIndex < slides.length - delta) ? currentSlideIndex + delta : 0;
      }

      prevSlideIndex = (currentSlideIndex - 1 >= 0) ? currentSlideIndex - 1 : slides.length - 1;
      nextSlideIndex = (currentSlideIndex < slides.length - 1) ? currentSlideIndex + 1 : 0;
    }

    function leftArrowHandler(e) {
      if (e) {
        e.preventDefault();
      }

      if (animating) {
        return;
      }

      direction = 'right';

      if (!self.opts.slideAnimation) {
        slides[currentSlideIndex].classList.remove('active');
      } else {
        animating = true;

        slides[prevSlideIndex].classList.add('animate-right');
        slides[prevSlideIndex].classList.add('prev');

        slides[currentSlideIndex].classList.add('animate-right');
        trackingHandler.vehicleCardInteraction('left');
      }

      updateIndexes();

      if (!self.opts.slideAnimation) {
        slides[currentSlideIndex].classList.add('active');
      }
    }

    function rightArrowHandler(e) {
      if (e) {
        e.preventDefault();
      }

      if (animating) {
        return;
      }

      direction = 'left';

      if (!self.opts.slideAnimation) {
        slides[currentSlideIndex].classList.remove('active');
      } else {
        animating = true;

        slides[nextSlideIndex].classList.add('animate-left');
        slides[nextSlideIndex].classList.add('next');

        slides[currentSlideIndex].classList.add('animate-left');
        trackingHandler.vehicleCardInteraction('right');
      }

      updateIndexes();

      if (!self.opts.slideAnimation) {
        slides[currentSlideIndex].classList.add('active');
      }
    }

    function removeClasses(el, classes) {
      classes.forEach((className) => {
        el.classList.remove(className);
      });
    }

    function removeElementsClasses(elements, classes) {
      for (let i = 0; i < elements.length; i++) {
        removeClasses(elements[i], classes);
      }
    }

    function removeAnimationState() {
      animating = false;

      if (slides.length && self.opts.slideAnimation) {
        removeElementsClasses(slides, ['animate-right', 'animate-left', 'active', 'prev', 'next']);
        removeElementsClasses(indicators, ['active']);

        slides[currentSlideIndex].classList.add('active');
      }

      if (indicators.length && self.opts.slideAnimation) {
        indicators[currentSlideIndex].classList.add('active');
      }

      self.update();
    }

    function attachAnimation(el) {
      animationEvents.forEach((event) => {
        el.removeEventListener(event, removeAnimationState);
        el.addEventListener(event, removeAnimationState);
      });
    }

    function indicatorHandler(e) {
      const target = parseInt(e.target.dataset.slideTo, 10);

      if (target === currentSlideIndex) {
        return;
      }

      direction = (target > currentSlideIndex) ? 'left' : 'right';

      if (self.opts.slideAnimation) {
        animating = true;
        trackingHandler.vehicleCardInteraction(`tab ${target}`);
        if (direction === 'left') {
          slides[target].classList.add('animate-left');
          slides[target].classList.add('next');

          slides[currentSlideIndex].classList.add('animate-left');
        } else if (direction === 'right') {
          slides[target].classList.add('animate-right');
          slides[target].classList.add('prev');

          slides[currentSlideIndex].classList.add('animate-right');
        }

        updateIndexes(Math.abs(target - currentSlideIndex));
      } else {
        slides[currentSlideIndex].classList.remove('active');

        updateIndexes(Math.abs(target - currentSlideIndex));

        slides[currentSlideIndex].classList.add('active');
      }
    }

    function handleGesture() {
      if (!touchEnd || !touchStart) {
        return false;
      }

      if (touchEnd < touchStart) {
        rightArrowHandler();
      }
      if (touchEnd > touchStart) {
        leftArrowHandler();
      }
      return true;
    }
    function handleTOuchStart(e) {
      touchStart = e.changedTouches[0].screenX;
    }

    function handleTOuchEnd(e) {
      touchEnd = e.changedTouches[0].screenX;
      handleGesture();
    }

    function attachHandlers() {
      if (leftArrow) {
        leftArrow.removeEventListener('click', leftArrowHandler);
        leftArrow.addEventListener('click', leftArrowHandler);
      }

      if (rightArrow) {
        rightArrow.removeEventListener('click', rightArrowHandler);
        rightArrow.addEventListener('click', rightArrowHandler);
      }

      if (indicators.length) {
        for (let i = 0; i < indicators.length; i++) {
          indicators[i].removeEventListener('click', indicatorHandler);
          indicators[i].addEventListener('click', indicatorHandler);
        }

        self.root.removeEventListener('touchstart', handleTOuchStart);
        self.root.removeEventListener('touchend', handleTOuchEnd);
        self.root.addEventListener('touchstart', handleTOuchStart);
        self.root.addEventListener('touchend', handleTOuchEnd);
      }

      if (self.opts.slideAnimation) {
        for (let i = 0; i < slides.length; i++) {
          attachAnimation(slides[i]);
        }
      }
    }

    function buildCarousel() {
      slides = self.root.querySelectorAll('.ui-slide');
      indicators = self.root.querySelectorAll('.ui-carousel-indicator');
      indicatorContainer = self.root.querySelector('.ui-carousel-indicators');
      leftArrow = self.root.querySelector('.ui-carousel-arrow-left');
      rightArrow = self.root.querySelector('.ui-carousel-arrow-right');

      if (slides.length) {
        slides[0].classList.add('active');

        prevSlideIndex = slides.length - 1;
        nextSlideIndex = 1;
      }

      if (slides.length === 1) {
        if (leftArrow) {
          leftArrow.classList.add('hide');
        }

        if (rightArrow) {
          rightArrow.classList.add('hide');
        }
      }

      if (indicators.length > 1) {
        indicators[0].classList.add('active');
      } else if (indicators.length === 1 && indicatorContainer) {
        indicatorContainer.classList.add('hide');
      }

      if (slides.length > 1) {
        attachHandlers();
      }
    }

    self.on('mount', () => {
      buildCarousel();
    });

    self.bus.on(self.bus.EVENTS.VEHICLE.UPDATED, buildCarousel);
});
